import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortAmountDesc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "Sort Descending"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M10 24v-24h-4v24h-5l7 7 7-7h-5z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 0h18v4h-18v-4z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 6h14v4h-14v-4z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 12h10v4h-10v-4z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 18h6v4h-6v-4z" })
	]
});
const ForwardRef = forwardRef(SvgSortAmountDesc);
export default ForwardRef;
